import { render, staticRenderFns } from "./TemplateSetup.vue?vue&type=template&id=4bf20e65&scoped=true"
import script from "./TemplateSetup.vue?vue&type=script&lang=js"
export * from "./TemplateSetup.vue?vue&type=script&lang=js"
import style0 from "./TemplateSetup.vue?vue&type=style&index=0&id=4bf20e65&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf20e65",
  null
  
)

export default component.exports